module.exports = __webpack_public_path__ + "static/media/cloud_and_sun.fc68a8b7.png";